import React, {Fragment} from "react";
import RealizationOrdersPage from "./RealizationOrdersPage";
import RealizationBranchesPage from "./RealizationBranchesPage";

function RealizationOrdersWrapper(props) {
  const {
    isSelectBranch,
  } = props;

  return (
    <Fragment>
      {isSelectBranch && (
        <RealizationOrdersPage {...props}/>
      )}
      {!isSelectBranch && (
        <RealizationBranchesPage {...props}/>
      )}
    </Fragment>
  );
}

export default RealizationOrdersWrapper;
